import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Bell, BellOff } from "lucide-react";

const POLL_MS = 15000;

const beep = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    [0, 0.18].forEach((t, i) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.frequency.value = i ? 1320 : 880;
      g.gain.setValueAtTime(0.25, ctx.currentTime + t);
      g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + t + 0.15);
      o.connect(g).connect(ctx.destination);
      o.start(ctx.currentTime + t);
      o.stop(ctx.currentTime + t + 0.16);
    });
  } catch {}
};

export function useNewOrderAlerts(api, onNew, enabled = true) {
  const last = useRef(null);
  useEffect(() => {
    if (!enabled) return;
    let alive = true;
    const check = async () => {
      try {
        const { data } = await api("get", "/admin/stats");
        const latest = data.latest;
        if (!alive) return;
        if (last.current === null) { last.current = latest?.created_at || ""; return; }
        if (latest && latest.created_at > last.current) {
          last.current = latest.created_at;
          const text = `${latest.order_code} · ${latest.athlete_name}${latest.bib_number ? ` (BIB ${latest.bib_number})` : ""}`;
          toast.success("Pesanan baru masuk!", { description: text, duration: 10000 });
          beep();
          if ("Notification" in window && Notification.permission === "granted") {
            new Notification("Pesanan baru – LENSA JUARA", { body: text, icon: "/assets/logo.png" });
          }
          onNew();
        }
      } catch {}
    };
    check();
    const id = setInterval(check, POLL_MS);
    return () => { alive = false; clearInterval(id); };
  }, [api, onNew, enabled]);
}

export function NotificationToggle() {
  const supported = typeof window !== "undefined" && "Notification" in window;
  const [perm, setPerm] = useState(supported ? Notification.permission : "denied");
  if (!supported) return null;
  const on = perm === "granted";
  return (
    <button
      data-testid="notif-toggle-btn"
      onClick={() => !on && Notification.requestPermission().then(setPerm)}
      className={`text-sm border px-3 py-1 flex items-center gap-1.5 transition-colors ${on ? "border-emerald-500/40 text-emerald-300" : "border-white/15 hover:border-[#FF5A00]"}`}
    >
      {on ? <Bell className="w-4 h-4" /> : <BellOff className="w-4 h-4" />}
      {on ? "Notifikasi aktif" : perm === "denied" ? "Notifikasi diblokir browser" : "Aktifkan notifikasi"}
    </button>
  );
}
